import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LOCALE } from './Constants';

// the translations
// (tip move them in a JSON file and import them)
// @todo create a file like above
const resources = {
    en: {
        translation: {
            core: {
                welcome: 'Welcome',
                clientId: 'Client ID',
                important: 'Important',
                action: {
                    modify: 'Modify',
                    cancel: 'Cancel',
                    back: 'Back',
                    submit: 'Submit',
                    next: 'Next',
                    review: 'Review',
                    save: 'Save',
                    loading: 'Loading..',
                    update: 'Update',
                    done: 'Done',
                    success: 'Success',
                    returnToLogin: 'Return to Login',
                    logout: 'Logout',
                },
                updateSuccess: 'Update completed successfully.',
            },
            api: {
                error: {
                    APPOINTMENT_NONE_AVAILABLE: 'We’re unable to book an appointment for this service. This may be because you are either not eligible for the selected service or have exceeded the allowed number of visits.\n\nPlease try selecting a different location or service.\n\nIf you continue to experience issues, we recommend reaching out directly to the organization for further assistance.',
                    APPOINTMENT_UPCOMING_NOT_FOUND: 'No upcoming appointments found.',
                    APPOINTMENT_NOT_ELIGIBLE: 'Not eligible for this appointment or have exceeded the allowed number of visits.',
                    APPOINTMENT_NOT_FOUND: 'Appointment not found.',
                    APPOINTMENT_POSTAL_RESTRICTED: 'Appointment can not be recorded because client is outside the allowed zip code range.',
                    APPOINTMENT_CITY_RESTRICTED: 'Appointment can not be recorded because client is outside the allowed cities.',
                    APPOINTMENT_COUNTY_RESTRICTED: 'Appointment can not be recorded because client is outside the allowed counties.',
                    APPOINTMENT_MUST_BE_IN_STATUS_MODIFY: 'Appointment must be in a pending status to modify.',
                    APPOINTMENT_MUST_BE_IN_PENDING_STATUS: 'Appointment must be in pending status to cancel.',
                    APPOINTMENT_MUST_BE_FUTURE_DATE: 'Appointment must be in the future.',
                    APPOINTMENT_NO_MODIFY_OR_CANCEL: 'This event is less than {{hours}} hours away. It cannot be changed or cancelled.',

                    NOT_FOUND: 'Not Found',
                    UNKNOWN: "We're sorry, something went wrong. Please try again. If you continue to experience issues, please contact us.",
                    ACCOUNT_DISABLED: 'This account has been disabled. Please contact the organization.'
                }
            },
            account: {
                createAccountStep2: 'Step 2 of 2: Security & Consent',
                disclaimer: 'Disclaimer',
                password: 'Password',
                passwordRequirements: 'Use at least 8 characters with a mix of letters and numbers',
                confirmPassword: 'Confirm Password',
                disabled: 'Account Disabled',
                consentContactEmailWarning: 'Please add your email in Account Information later',
                consentContactSMSWarning: 'Please add your phone number in Account Information later',
                exists: {
                    heading: 'Account Exists',
                    text: 'Based on the information you have provided, we believe that you already have a CNCT Account. You are able to login with the account that you already setup, or perform our password reset process if you cannot remember your login details.',
                    return: 'Return to Login',
                },
                id: {
                    doNotHaveButton: "I Don't Have This",
                    notFound: 'That ID Could Not Be Found',
                },
                create: {
                    atLeastOne: 'At Least One',
                    yourLogin: 'Your Login ID is',
                },
                consent: {
                    shareInformationLabel: 'I agree to share my information with food pantries and service providers to receive assistance. This information will be kept confidential.',
                    toContactLabel: ' Consent to Contact',
                    toContactEmail: 'Consent to Contact via Email',
                    toContactSMS: 'Consent to Contact via Text Message (SMS)',
                    toContactVoice: 'Consent to Contact via Voice',
                },
                confirmation: {
                    heading: 'Account Created Successfully',
                    yourLogin: 'Your Login ID',
                    yourClientId: 'Your Client ID',
                    message: 'Keep this ID for your records. You may be asked for this ID when you visit a service location.',
                },
            },
            address: {
                heading: 'Address',
                addressLine1: 'Address Line 1',
                addressLine2: 'Address Line 2',
                city: 'City',
                county: 'County',
                state: 'State',
                zipcode: 'Zipcode',
                noFixedAddress: 'No Fixed Address',
                addressDeclinedToAnswer: 'Prefer Not to Answer',
            },
            personal: {
                firstName: 'First Name',
                lastName: 'Last Name',
                email: 'Email',
                confirmEmail: 'Confirm Email',
                phone: 'Phone',
                confirmPhone: 'Confirm Phone',
                emailAndPhone: 'Email and Phone',
                emailAndOrPhone: 'At least one contact method (email or phone) is required',
                dob: 'Date of Birth',
                age: 'Age',
                newUserHeading: 'Don\'t have an account?',
                existingUserHeading: 'Sign In',
                emailOrPhone: 'Email or Phone Number',
                enterEmailOrPhone: 'Enter email or phone',
                createAccount: 'Create Account',
                createAccountStepOne: 'Step 1 of 2: Basic Information',
                enterPassword: 'Enter password',
            },
            intake: {
                heading: 'Profile Information',
                step1Of3: 'Step 1 of 3: Help us understand your needs',
                step2Heading: 'Household Members',
                step2Of3: 'Step 2 of 3: Help us understand your household members',
                step3Heading: 'Household Information',
                step3Of3: 'Step 3 of 3: Help us understand your household members',
                noHouseholdMembers: 'No household members added',
                noHouseholdMembersDescription:
                    'Add household members below.',
                addMember: 'Add Member',
                householdMember: 'Household Member',
                dobHelper: 'We use this for demographic reporting on age only.',
                gender: 'Gender Identity',
                ethnicities: 'Ethnicity',
                ethnicities_alternate: 'Race',
                isHispanicLatino: 'Ethnicity',
                housingType: 'Housing Type',
                education: 'Highest Education Level Completed',
                employment: 'Employment Type',
                selfIdentifiesAs: 'Self-Identifies As',
                incomeType: 'Income Type',
                incomeAmount: 'Income Amount',
                incomeTypeHeading: 'Primary Income',
                otherIncomes: 'Other Income Sources',
                maritalStatus: 'Marital Status',
                householdMembers: 'How many other people live in your household (not including you)?',
                referredBy: 'Referred By',
                relationships: 'Relationship',
                socialPrograms: 'Receiving the Following Household Social Programs',
                expenses: 'Expense Type',
                expenseAmount: 'Expense Amount',
                addExpense: 'Add Expense',
                dietaryConsiderationTypes: 'Dietary Considerations',
                languageTypes: 'Languages',
                dobEstimated: 'Is Date of Birth Estimated?',
                reviewHeading: 'Review Your Profile',
                reviewText: 'Please review your information before continuing',
                personalInformationHeading: 'Personal Information',
                name: 'Name',
                hhMemberHeading: 'Household Members',
                otherHouseholdMembers: 'Other Household Members',
                clientDetailsHeading: 'Client Details',
                householdDetailsHeading: 'Household Information',
                reviewPrivacyNotice:
                    'Your information is kept private and secure. You can update this information at any time from your dashboard.',
                notFilledValue: 'not filled',
                review: {
                    relationship: 'Relationship to Me:',
                },
            },
            appointment: {
                heading: 'Book Services',
                agency: 'Location',
                program: 'Program',
                startDate: 'Book Services Between',
                endDate: 'and',
                selectTimeSlot: 'Please select a preferred time slot from the following.',
                selectTimeSlotButton: 'Select Time Slot',
                confirmAppointmentHeading: 'Confirm Appointment',
                confirmAppointmentSubheading: 'Please review your appointment details',
                appointmentDetailsHeading: 'Appointment Details',
                dateAndTime: 'Date & Time',
                requestItemsLabel: 'Request Food/Items',
                requestItemsHint: 'Please note, we may not be able to accommodate all requests',
                addNotesLabel: 'Add Notes',
                addNotesHint: 'Additional information or special requests',
                addNotesPlaceholder: 'Add any additional information or special requests...',
                confirmationDisclaimer:
                    'By confirming this appointment, you agree to arrive on time and notify us at least {{hours}} hours in advance if you need to cancel or reschedule.',
                confirmationMissingContext: 'Your selected appointment could not be found. Please choose a time slot again.',
                confirmAppointmentButton: 'Confirm Appointment',
                backToScheduleButton: 'Back to Schedule',
                selectDayPrompt: 'Select a day to view available appointment times.',
                chooseTimeRange: 'Choose a time range:',
                selectPreferredTimePrompt: 'Please select your preferred appointment time.',
                slotAvailableSingular: 'Slot Available',
                slotAvailablePlural: 'Slots Available',
                slotSingular: 'slot',
                slotPlural: 'slots',
                timeRanges: {
                    morning: {
                        title: 'Morning',
                        hours: '6:00 AM - 11:00 AM',
                    },
                    midday: {
                        title: 'Midday',
                        hours: '11:00 AM - 2:00 PM',
                    },
                    afternoon: {
                        title: 'Afternoon',
                        hours: '2:00 PM - 5:00 PM',
                    },
                },
                noSlotsHeading: 'No Appointments Available',
                noSlotsForSelection: 'No open appointments at {{org}} between {{start}} and {{end}}. Try selecting a different date range.',
                seeMore: 'See more',
                modifyMessage: 'You are modifying the following service.',
                modifyHeading: 'Modify Appointment',
                modifyDescription:
                    'To reschedule your appointment, you\'ll search for a new available time slot. Your current appointment will be replaced with the new one you select.',
                findNewTime: 'Find New Time',
                keepCurrentAppointment: 'Keep Current Appointment',
                modifyCancelNoteLabel: 'Note:',
                modifyCancelNoteText:
                    'If you need to cancel instead, please go back and select Cancel from your upcoming services.',
                book: 'Book',
                booking: 'Booking',
            },
            bookingConfirmed: {
                heading: 'Appointment Confirmed',
                subheading: 'Your appointment has been successfully booked.',
                detailsHeading: 'Appointment Details',
                dateTimeLabel: 'Date & Time',
                locationLabel: 'Location',
                appointmentTypeLabel: 'Appointment Type',
                clientIdLabel: 'Client ID',
                whatToBringLabel: 'What to bring',
                whatToBringText: 'Please bring your Client ID and a form of identification when you arrive for your appointment.',
                viewUpcomingButton: 'View Upcoming Services',
            },
            upcomingAppointments: {
                heading: 'Upcoming Services',
                cancelConfirmation: 'Are you sure you want to cancel this service?',
                supportNotice: 'Please provide {{hours}} hours notice for any cancellation or changes.',
            },
            dashboard: {
                heading: 'User Dashboard',
                bookServices: 'Book Services',
                bookServicesDescription: 'Schedule an appointment',
                bookPickup: 'Book Pickup',
                bookPickupDescription: 'Schedule a pickup appointment',
                bookDelivery: 'Book Delivery',
                bookDeliveryDescription: 'Schedule a delivery appointment',
                upcomingServices: 'View Upcoming Services',
                upcomingServicesDescription: 'See your scheduled appointments',
                return: 'Return to Dashboard',
                updateInfo: 'Update Account Info',
                updateInfoDescription: 'Change your contact and login details',
                updateProfile: 'Update Profile Information',
                updateProfileDescription: 'Change your profile or household details',
            },
            user: {
                username: 'Username',
                password: 'Password',
                login: 'Login',
                verification: 'Verification',
                verify: 'Verify',
                verified: 'Verified',
                verifyNow: 'Verify Now',
                resendCode: 'Resend Code',
                verificationCode: 'Verification Code',
                verificationCodeSent:
                    'A verification code has been sent to your email or phone to complete your account setup.',
                verificationText:
                    'Please verify your contact details so that you can reset your password in case you forget.',
                email: 'Email',
                phone: 'Phone Number',
                forgotPassword: 'Forgot Password?',
                forgotPasswordCodeSent:
                    'Your verified {{value}} has been sent a recovery code. Please enter it here and your new password to complete the password reset.',
                forgotPasswordSuccess:
                    'Your new password has been set successfully, please login below with your new password.',
                newPassword: 'New Password',
                confirmNewPassword: 'New Password (Again)',
                noConfirmedEmailPhoneMessage:
                    'We cannot reset password as this account has not been verified. Please contact {{network}} to reset your password for you.',
                passwordReset: {
                    heading: 'Password Reset',
                    text: 'Please enter your email and/or phone number to reset your password. If you have an account, you will receive an email or text message shortly with instructions. If you continue to have challenges, please reach out to the organization by phone or email.',
                    thankYouMessage:
                        'Thank you! An email or text has been sent with instructions. Please check your email or text at {{username}} for a link to reset your password.',
                },
            },
            updateUser: {
                heading: 'Update Information',
                currentPassword: 'Current Password',
            },
            session: {
                apiSessionNotFound: 'Client session not found.',
                sessionExpiredNotice:
                    'Your session has expired due to inactivity. Please re-enter your {{dob_label}} and submit the form.',
                sessionExpiredGeneralNotice: 'Your session has expired due to inactivity. Please reload the page',
            },
            confirmAddress: {
                heading: 'Please confirm your address below for the delivery',
                useThisAddress: 'Use This Address',
                updateMyAddress: 'Update my Address',
            },
            updateAddress: {
                heading: 'Please add your home address for delivery',
            },
            delivery: {
                heading: 'Book Delivery',
                startDate: 'Book Delivery Between',
                noSlots: 'We’re sorry, no delivery is available for your location currently.',
                consentContactEnabled: 'You will receive a confirmation email/SMS prior to your delivery.',
                consentContactDisabled: `You currently have not allowed the organization to contact you. The organization's delivery system uses text (SMS) or email. Please opt in if you would like delivery confirmations and notifications. You can change these settings by updating your <0>Account Information</0>.`,
                provisionsLabel:
                    '<0>Foods/Items Requested</0> <1>(Please note, we may not be able to accommodate all requests)</1>',
                deliveryNotesLabel:
                    '<0>Delivery Notes</0> <1>(Special delivery instructions for example, “please ring the 2nd buzzer from the top” or “leave it on the porch”)</1>',
                nonDeliveryNotesLabel: '<0>Notes</0>',
                consentContactWarning:
                    "The organization's delivery system uses text (SMS) or email. Please opt in if you would like delivery confirmations and notifications.",
            },
            pickup: {
                heading: 'Book Pickup',
                startDate: 'Book Pickup Between',
            },
        },
    },
    en_ca: {
        translation: {
            address: {
                state: 'Province',
                zipcode: 'Postal Code',
            },
            intake: {
                ethnicities: 'Racial Identity',
            },
            api: {
                error: {
                    APPOINTMENT_POSTAL_RESTRICTED: 'Appointment can not be recorded because client is outside the allowed postal code range.',
                    APPOINTMENT_COUNTY_RESTRICTED: 'Appointment can not be recorded because client is outside the allowed wards.',
                }
            },

        },
    },
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: LOCALE,
        fallbackLng: 'en',

        keySeparator: '.', // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
